export default __webpack_public_path__ + "static/media/cases-thumbnail.3985506e.jpg";